import { fetchSignInData } from "@/service/auth";
import { ElNotification } from "element-plus";

export default {

  data() {
    return {
      loginProcessing: false,
      errorMsg: "",
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, message: "Email is required", trigger: "blur" },
          { type: "email", message: "Please enter a valid email address", trigger: ["blur", "change"] },
        ],
        password: [
          { required: true, message: "Password is required", trigger: "blur" },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            message: "Password must have 8+ characters, one letter, one number, one special char",
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    loggedIn() {
      return this.$store.getters.isAuthenticated;
    },
  },
  created() {
    if (this.loggedIn && this.$route.name === "login-page") {
      this.$router.push({ name: "email-dashboard" });
    }
  },

  methods: {
    showNotification(type, title, message) {
      ElNotification({
        type,
        title,
        message,
        duration: 3000,
      });
    },

    async validateForm() {
      if (!this.$refs.form) {
        console.error("Form reference not found!");
        return false;
      }

      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => resolve(valid));
      });
    },

    async onLoginSubmit() {
      this.errorMsg = "";
      this.loginProcessing = true;

      try {
        const result = await fetchSignInData(this.loginForm);

        if (result.data && result.data.user_id) {
          this.$store.dispatch("loginUser", result.data);

          this.showNotification("success", "Login Successful");
          this.$router.push({ name: "email-dashboard" });

        } else {
          this.errorMsg = "Invalid credentials. Please try again.";
          setTimeout(() => {
            this.showNotification("error", "Login Failed", this.errorMsg);
          }, 500);
        }

      } catch (error) {
        console.error("🔥 Login Error:", error);
        this.errorMsg = error?.response?.data?.message || "Incorrect Password";
        this.showNotification("error", "Login Error", this.errorMsg);

      } finally {
        this.loginProcessing = false;
      }
    },
  },
};